exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active[data-v-64da9742],.list-leave-active[data-v-64da9742]{-webkit-transition:all .4s;transition:all .4s}.list-enter[data-v-64da9742],.list-leave-to[data-v-64da9742]{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}.load-more[data-v-64da9742]{width:auto;height:32px;padding:5px 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64da9742","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/LoadMore.vue
// module id = Udhl
// module chunks = 0 1